import { UtilAction, UtilActionsTypes } from './types'

interface InitialStateI {
	isPost: boolean
}

const initialState: InitialStateI = {
	isPost: true,
}

export const utilReducer = (
	state: InitialStateI = initialState,
	action: UtilAction
) => {
	switch (action.type) {
		case UtilActionsTypes.setIsPost: {
			return {
				...state,
				isPost: action.payload,
			}
		}
		default:
			return state
	}
}
